// extracted by mini-css-extract-plugin
export default {"mainClass":"reports_mainClass__bHQKw","h1":"reports_h1__N+kKS","tabClass":"reports_tabClass__AKA2o"};